import React, { useState } from 'react';
import { Tabs, Select } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import styles from './StoreList.module.scss';
import StoreListItem from './StoreListItem';
import { IStoreDataAll } from './types';

interface StoreListProps {
  goodsList: IStoreDataAll[];
}

const StoreList: React.FC<StoreListProps> = ({ goodsList }) => {


	return (
		<div className={styles['store-list-container']}>
		

			{/* 店铺列表 */}
			<div className={styles['store-list']}>
				{goodsList.map((item) => (
					<StoreListItem item={item} key={item?.merchant_id} />
				))}
			</div>
		</div>
	);
};

export default StoreList; 